import React, { useState, useEffect } from 'react';
import {
    Container,
    Typography,
    Paper,
    Button,
    Pagination,
    Box,
    CircularProgress,
    Alert,
    TextareaAutosize,
    createTheme,
    ThemeProvider,
    Grid,
    Tab,
    Tabs,
} from '@mui/material';
import Layout from '../../components/Layout/Layout'
import { styled } from '@mui/material/styles';
import { CustomTabPanel } from '../Users/UserInLineEditView/UserInLineEditView';
import ConfigSettings from '../DBSettings/ConfigSettings/ConfigSettings';
import ShopConfig from '../DBSettings/ShopCoins/ShopConfig';
import { getKaratPromoOffer, getPromoCode } from '../../API/SponsoredAPI/SponsoredApi';
import Promotion from './Promotion';

const theme = createTheme({
    palette: {
        primary: {
            main: '#1976d2',
        },
    },
    typography: {
        fontFamily: 'Roboto, sans-serif',
    },
});

const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(2), 
    marginBottom: theme.spacing(2),
}));

 const dummyOffers = [
    {
      gameID: "GAME123",
      promoType: "Winner",
      teamName: "Falcons",
      opponentTeamName: "Eagles",
      teamKey: "ATL",
      opponentTeamKey: "PHI",
      leagueName: "NFL",
      promoTitle: "Falcons Victory Giveaway",
      promoDescription: "Win exclusive prizes if the Falcons win!",
      gameTime: "2025-07-01T20:00:00Z",
      winPromoCode: "WINFALCONS2025",
      selectedTeamColor: "#1E90FF",
      teamColor: "#1E90FF",
      opponentColor: "#FF6347",
      sponsorDetails: {
        logoUrl: "https://dummyimage.com/50x50/000/fff&text=S",
        websiteUrl: "https://sponsor.example.com",
        imageUrl: "https://dummyimage.com/300x200/70aa2c/fff&text=Prize",
        termsConditionsUrl: "https://sponsor.example.com/terms",
        sponsorName: "Super Sponsor",
        expiredDate: "2025-07-15T23:59:59Z",
        maxParticipantsLimit: 1000,
      },
    },
    {
      gameID: "GAME456",
      promoType: "Karat",
      teamName: "Warriors",
      opponentTeamName: "Lakers",
      teamKey: "GSW",
      opponentTeamKey: "LAL",
      leagueName: "NBA",
      promoTitle: "Golden Shot",
      promoDescription: "Cheer for the Warriors and get a chance to win gold!",
      gameTime: "2025-07-05T19:30:00Z",
      winPromoCode: "GOLD2025",
      selectedTeamColor: "#FFD700",
      teamColor: "#FFD700",
      opponentColor: "#800080",
      sponsorDetails: {
        logoUrl: "https://dummyimage.com/50x50/000/fff&text=G",
        websiteUrl: "https://golden.sponsor.com",
        imageUrl: "https://dummyimage.com/300x200/FFD700/000&text=Gold+Prize",
        termsConditionsUrl: "https://golden.sponsor.com/terms",
        sponsorName: "Golden Sponsor",
        expiredDate: "2025-07-20T23:59:59Z",
        maxParticipantsLimit: 500,
      },
    },
  ];

  
function Sponsored(props) {
    const token = sessionStorage.getItem("token");
    const [value, setValue] = useState(0);
    const [promoOffers, setPromoOffers] =useState([]);
    const [loading, setLoading] = useState(false);
    const [limit,setLimit] = useState(0);
    const [page, setPage] = useState(1);

    useEffect(()=>{
        setLimit(0);
        setPromoOffers([]);
        setLoading(true);
        getKaratPromoOffer(
            token,
            limit,
            value === 0 ? 'Available' : 'Settled',
            true,
          )
            .then(res => {
              console.log('KaratPromoOffers : ', res?.data);
              setPromoOffers(res?.data?.populatedOffers);
            //   setPromoOffers(dummyOffers);
              
              setLoading(false);
            })
            .catch(err => {
              console.log(err);
              setLoading(false);
            });
    },[value])

const handleViewMore =() =>{
     setLimit(limit + promoOffers?.length);
     getKaratPromoOffer(
        token,
        limit+ promoOffers?.length,
        value === 0 ? 'Available' : 'Settled',
        true,
      )
        .then(res => {
          console.log('KaratPromoOffers : ', res?.data);
          if (res?.data?.populatedOffers?.length) {
            setPromoOffers(prev => [...prev, ...res.data.populatedOffers]);
          }
        //   setPromoOffers(dummyOffers);
          
          setLoading(false);
        })
        .catch(err => {
          console.log(err);
          setLoading(false);
        });
}

    const handleChange = (event, newValue) => {
        setValue(newValue);
      };
      function a11yProps(index) {
        return {
          id: `simple-tab-${index}`,
          "aria-controls": `simple-tabpanel-${index}`,
        };
      }

  return (
    <Layout>
       
         <Box sx={{  borderColor: "divider", width: "100%",mt:2,pl:2 }}>
    <Tabs
      value={value}
      onChange={handleChange}
      //   centered
      variant="scrollable"
      scrollButtons="auto"
      aria-label="scrollable auto tabs example"
      textColor="primary"
      indicatorColor="primary"
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        borderBottom: 1,
        borderColor: "divider",
      }}
    >
      <Tab
        label="Available Offers"
        {...a11yProps(0)}
        style={{ fontWeight: "700" }}
      />
      <Tab
        label="Settled Offers"
        {...a11yProps(1)}
        style={{ fontWeight: "700" }}
      />
     
      
    </Tabs>

    <CustomTabPanel value={value} index={0}>
       <Promotion offers={promoOffers} loading={loading} value={value} handleViewMore={handleViewMore} />
   </CustomTabPanel>

   <CustomTabPanel value={value} index={1}>
      <Promotion offers={promoOffers} loading={loading} value={value} handleViewMore={handleViewMore} />
    </CustomTabPanel>

  </Box>

 
        </Layout>
  )
}

export default Sponsored